import { useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const FIELDS = [
  ["automation_errors_24h", "Avvisa da N errori automazioni in 24 ore (per cliente)"],
  ["outbox_failed_24h", "Avvisa da N email non consegnate in 24 ore (per cliente)"],
  ["outbox_stuck_min", "Coda email bloccata dopo (minuti)"],
  ["automation_stuck_min", "Automazione ferma dopo (minuti)"],
  ["cooldown_min", "Anti-rumore: riapri lo stesso avviso entro (minuti)"],
];

export function OpsRulesDialog({ rules, onClose, onSaved }) {
  const api = useApi();
  const [r, setR] = useState(rules);
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/ops-alerts/rules", r); toast.success("Soglie salvate"); onSaved(); onClose(); } catch (e) { toast.error(errMsg(e)); }
    setSaving(false);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="ops-rules-dialog">
        <DialogHeader><DialogTitle className="text-base">Soglie degli avvisi</DialogTitle></DialogHeader>
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={r.enabled} onChange={(e) => setR({ ...r, enabled: e.target.checked })} data-testid="ops-rules-enabled" />Controlli automatici attivi</label>
        <div className="space-y-2">
          {FIELDS.map(([k, label]) => (
            <label key={k} className="flex items-center justify-between gap-3 text-sm text-slate-700">{label}
              <Input type="number" min={0} value={r[k]} onChange={(e) => setR({ ...r, [k]: Number(e.target.value) })} className="h-9 w-24" data-testid={`ops-rules-${k}`} />
            </label>
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} data-testid="ops-rules-cancel">Annulla</Button>
          <Button onClick={save} disabled={saving} data-testid="ops-rules-save">Salva</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
